// extracted by mini-css-extract-plugin
export default {"licensing":"LicenseContainer-module__licensing___6Q+oV"};